export const GameConfig = {
  // Session
  sessionDuration: 180,
  ordersToWin: 5,

  // Machines - base durations
  machineAProcessTime: 4000,
  machineBProcessTime: 5000,

  // Upgrades: level 1 & 2 costs
  machineAUpgradeCosts: [100, 250],
  machineBUpgradeCosts: [150, 300],
  machineAUpgradeSpeed: [0.75, 0.55], // multiplier (0.75 = nhanh hơn 25%)
  machineBUpgradeSpeed: [0.75, 0.55],

  // Orders
  orderDeadlineBase: 60,
  rewardPerUnit: 30,

  // Difficulty scaling
  difficultyOrderCount: [0, 2, 4], // sau mỗi mốc này đơn khó hơn
  deadlineReduction: [0, 10, 20],   // giảm deadline
  quantityIncrease: [0, 0, 1],      // tăng số lượng cơ bản
  maxProductsPerOrder: 2,           // đơn phức tạp: tối đa 2 loại SP

  // Economy
  earlyBonusThreshold: 0.5,

  // Effects
  shakeDuration: 100,
  shakeIntensity: 0.005,
  particleCount: 8,
  particleLife: 600,
};
